// extracted by mini-css-extract-plugin
module.exports = {"column":"LinkedCardsSection_column__AJX4m","column_not-hovered":"LinkedCardsSection_column_not-hovered__6BcVa"};